import React, {useEffect, useReducer} from 'react';
import {Button, Form, Modal} from '@themesberg/react-bootstrap';
import {FormattedMessage} from 'react-intl';
import {Map, Marker, TileLayer, useLeaflet} from 'react-leaflet';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUser, faCreditCard, faCircleCheck} from '@fortawesome/free-solid-svg-icons';
import API from '../../services/API';
import Utils from '../../services/Utils';
import queryString from 'query-string';
import FieldRow from '../../components/FieldRow';
import {useHistory} from 'react-router-dom';

export default (props) => {

  const ResizeMap = () => {
    const leaflet = useLeaflet();
    leaflet.map.invalidateSize();
    return null;
  };

  const formReducer = (state, event) => {
    if (event.value !== undefined) {
      return {
        ...state,
        [event.name]: event.value
      }
    } else {
      return event;
    }
  }

  const {intl, switchLanguage} = props;
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [booked, setBooked] = React.useState(false); // (iOS only)
  const [paymentUrl, setPaymentUrl] = React.useState(''); // (iOS only)
  const [formData, setFormData] = useReducer(formReducer, {});
  const [bookingInfos, setBookingInfos] = React.useState({});
  const [paymentMode, setPaymentMode] = React.useState('DRIVER');
  const [validDiscount, setValidDiscount] = React.useState(undefined);
  const [discountPrice, setDiscountPrice] = React.useState(undefined);
  const [discountMessage, setDiscountMessage] = React.useState('');
  const [discountFailMessage, setDiscountFailMessage] = React.useState('');
  const [showCgv, setShowCgv] = React.useState(false);
  const params = queryString.parse(props.location.search);
  const id = params.id;
  const lang = params.lang;
  const [formatter, setFormatter] = React.useState(new Intl.NumberFormat(navigator.language, {style: 'currency', currency: 'EUR'}));

  useEffect(() => {
    if (lang && lang !== intl.locale) {
      switchLanguage(lang);
    }
  }, [lang, intl.locale, switchLanguage]);

  useEffect(() => {
    if (id) {
      if (id === 'preview') {
        if (!Utils.isAccessToken(history)) {
          return;
        }
        API.getBookingPreview(history).then(response => {
          if (response && response.data.success === true) {
            setBookingInfos(response.data.data);
            if (!(response.data.data.driverPayments === true && response.data.data.onlinePayments === true)) {
              setPaymentMode(response.data.data.onlinePayments === true ? 'ONLINE' : 'DRIVER');
            }
          } else {
            Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
          }
        });
      } else {
        API.getBooking(id, lang).then(response => {
          if (response && response.data.success === true) {
            setBookingInfos(response.data.data);
            if (!(response.data.data.driverPayments === true && response.data.data.onlinePayments === true)) {
              setPaymentMode(response.data.data.onlinePayments === true ? 'ONLINE' : 'DRIVER');
            }
            setFormatter(new Intl.NumberFormat(navigator.language, {
              style: 'currency',
              currency: response.data.data.currency,
            }));
          } else if (response && response.data.success === false && response.data.data) {
            window.location.replace(response.data.data);
          } else {
            Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
          }
        });
      }
    }
  }, [intl]);

  const handleChange = event => {
    setFormData({
      name: event.target.id,
      value: event.target.value
    });
  }

  const handleApplyDiscount = (e) => {
    if (id === 'preview') {
      return;
    }
    API.getDiscount(id, formData.discountCode).then(response => {
      if (response && response.data.success === true) {
        if (response.data.data.discount) {
          setValidDiscount(true);
          setDiscountPrice(response.data.data.discountPrice);

          const fixedDiscount = response.data.data.fixedDiscount;
          const percentageDiscount = response.data.data.percentageDiscount;
          if (fixedDiscount && percentageDiscount) {
            setDiscountMessage(intl.formatMessage({id: 'DISCOUNT_MESSAGE'}, {discount: (percentageDiscount + ' %') + ' + ' + formatter.format(fixedDiscount)}));
          } else {
            setDiscountMessage(intl.formatMessage({id: 'DISCOUNT_MESSAGE'}, {discount: (fixedDiscount ? formatter.format(fixedDiscount) : percentageDiscount + ' %')}));
          }
        } else {
          setValidDiscount(false);
          const minAmount = response.data.data.minAmount;
          if (minAmount) {
            setDiscountFailMessage(intl.formatMessage({id: 'DISCOUNT_CODE_FAIL_MIN_AMOUNT'}, {minAmount: formatter.format(minAmount)}));
          } else {
            setDiscountFailMessage(intl.formatMessage({id: 'DISCOUNT_CODE_FAIL'}));
          }
        }
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (id === 'preview') {
      return;
    }

    if (paymentUrl) {
      window.open(paymentUrl, '_blank');
    } else {
      formData.paymentMode = paymentMode;
      formData.consent = intl.formatMessage({id: 'RGPD'});

      if (!formData.country) {
        formData.country = intl.locale === 'fr' ? 'FR' : 'US';
      }

      setLoading(true);
      API.postCheckout(formData, id, intl.locale).then(response => {
        const isIos = /iPad|iPhone|iPod/.test(navigator.platform);
        if (paymentMode === 'ONLINE') {
          if (isIos) {
            setLoading(false);
            setPaymentUrl(response.data);
          } else {
            window.location.replace(response.data);
          }
        } else if (paymentMode === 'DRIVER') {
          alert(intl.formatMessage({id: 'ALERT_BOOKING_MADE'}));
          if (isIos) {
            setBooked(true);
          } else {
            window.location.replace(bookingInfos.redirectionUrl ? bookingInfos.redirectionUrl : bookingInfos.url);
          }
        }
      }).catch(error => {
        if (error.response && error.response.status === 409 && error.response.data) {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), error.response.data);
        } else {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
        }
        setLoading(false);
      });
    }
  }

  const getArrayCoords = (coords) => {
    const split = coords.split(',');
    const arrayCoords = [];
    arrayCoords.push(split[0]);
    arrayCoords.push(split[1]);
    return arrayCoords;
  }

  const getNullableArrayCoords = (coords) => {
    if (coords) {
      const split = coords.split(',');
      const arrayCoords = [];
      arrayCoords.push(split[0]);
      arrayCoords.push(split[1]);
      return arrayCoords;
    }
    return [46.41, 2.05];
  }

  return (
    <main className="ccv2-booking">
      {id &&
        <Form className={`ccv2-booking-shell ${booked ? 'is-booked' : ''}`} onSubmit={handleSubmit}>
          <div className={`ccv2-booking-grid ${booked ? 'is-booked' : ''}`}>

            {/* ───── Colonne formulaire (masquée si réservation iOS confirmée) ───── */}
            {!booked &&
              <div className="ccv2-booking-main">

                {/* Ancre trajet compacte — mobile uniquement */}
                <section className="ccv2-trip-card d-lg-none">
                  <div className="ccv2-trip-route">
                    <span className="ccv2-trip-node is-origin">
                      <i className="ccv2-trip-dot"/>
                      <span className="ccv2-trip-addr">{bookingInfos.startingAddress}</span>
                    </span>
                    {bookingInfos.arrivalAddress &&
                      <span className="ccv2-trip-node is-dest">
                        <i className="ccv2-trip-dot"/>
                        <span className="ccv2-trip-addr">{bookingInfos.arrivalAddress}</span>
                      </span>
                    }
                  </div>
                  <div className="ccv2-trip-meta">
                    {bookingInfos.pickUpTime && <span className="ccv2-chip">{bookingInfos.pickUpTime}</span>}
                    {bookingInfos.vehicle && <span className="ccv2-chip">{bookingInfos.vehicle}</span>}
                    <span className="ccv2-chip">{bookingInfos.route === 'ROUND_TRIP' ? intl.formatMessage({id: 'ROUND_TRIP'}) : intl.formatMessage({id: 'ONE_WAY'})}</span>
                    {bookingInfos.returnPickUpTime && <span className="ccv2-chip">{bookingInfos.returnPickUpTime}</span>}
                  </div>
                  <div className="ccv2-trip-price">{formatter.format(validDiscount ? discountPrice : bookingInfos.price)}</div>
                </section>

                {/* Vos informations — champs dynamiques + code promo */}
                <section className="ccv2-card">
                  <header className="ccv2-card-head">
                    <span className="ccv2-card-icon"><FontAwesomeIcon icon={faUser}/></span>
                    <div className="ccv2-card-titles">
                      <div className="ccv2-card-title">{intl.formatMessage({id: 'YOUR_DETAILS'})}</div>
                    </div>
                  </header>
                  <div className="ccv2-card-body">
                    {bookingInfos.fields && bookingInfos.fields.map((data, index) =>
                      <FieldRow key={index} intl={intl} handleChange={handleChange} validDiscount={validDiscount}
                                discountFailMessage={discountFailMessage} formData={formData}
                                bookingInfos={bookingInfos} handleApplyDiscount={handleApplyDiscount} {...data}/>)}
                  </div>
                </section>

                {/* Paiement */}
                <section className="ccv2-card">
                  <header className="ccv2-card-head">
                    <span className="ccv2-card-icon"><FontAwesomeIcon icon={faCreditCard}/></span>
                    <div className="ccv2-card-titles">
                      <div className="ccv2-card-title">{intl.formatMessage({id: 'PAYMENT'})}</div>
                    </div>
                  </header>
                  <div className="ccv2-card-body">
                    {(bookingInfos.driverPayments && bookingInfos.onlinePayments) ?
                      <div className="ccv2-pay-toggle" role="tablist">
                        {['DRIVER', 'ONLINE'].map(mode =>
                          <button type="button" key={mode} role="tab" aria-selected={paymentMode === mode}
                                  className={`ccv2-pay-option ${paymentMode === mode ? 'is-active' : ''}`}
                                  onClick={() => setPaymentMode(mode)}>
                            {intl.formatMessage({id: mode === 'DRIVER' ? 'DRIVER_PAYMENT' : 'ONLINE_PAYMENT'})}
                          </button>)}
                      </div>
                      :
                      <div className="ccv2-pay-fixed">
                        {intl.formatMessage({id: bookingInfos.onlinePayments ? 'ONLINE_PAYMENT' : 'DRIVER_PAYMENT'})}
                      </div>
                    }
                    <p className="ccv2-pay-note">
                      {intl.formatMessage({id: paymentMode === 'DRIVER' ? 'TOOLTIP_DRIVER_PAYMENT' : 'TOOLTIP_ONLINE_PAYMENT'})}
                    </p>
                  </div>
                </section>

                {/* Consentement RGPD (+ CGV du chauffeur s'il en a) : inputs natifs required */}
                <div className="ccv2-consent">
                  {bookingInfos.cgv &&
                    <Form.Check required id="checkboxCGV"
                                checked={!!formData.cgvAccepted}
                                onChange={e => setFormData({name: 'cgvAccepted', value: e.target.checked})}
                                label={<FormattedMessage id="CGV_ACCEPT" values={{
                                  link: chunks => bookingInfos.cgv.type === 'URL'
                                    ? <a className="ccv2-cgv-link" href={bookingInfos.cgv.url} target="_blank" rel="noopener noreferrer">{chunks}</a>
                                    : <button type="button" className="ccv2-cgv-link" onClick={() => setShowCgv(true)}>{chunks}</button>
                                }}/>}/>}
                  <Form.Check required id="checkboxRGPD" label={intl.formatMessage({id: 'RGPD'})}/>
                </div>
              </div>
            }

            {/* ───── Rail : confirmation + carte + récap + remise + CTA ───── */}
            <aside className="ccv2-booking-rail">
              {booked &&
                <div className="ccv2-booked">
                  <span className="ccv2-booked-icon"><FontAwesomeIcon icon={faCircleCheck}/></span>
                  <h2 className="ccv2-booked-title">{intl.formatMessage({id: 'BOOKING_MADE'})}</h2>
                </div>
              }

              <div className="ccv2-map">
                <Map center={getNullableArrayCoords(bookingInfos.startingCoords)} zoom={7} scrollWheelZoom={true} style={{width: '100%', height: '100%'}}>
                  <ResizeMap/>
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  {bookingInfos.startingCoords && <Marker position={getArrayCoords(bookingInfos.startingCoords)}/>}
                  {bookingInfos.arrivalCoords && <Marker position={getArrayCoords(bookingInfos.arrivalCoords)}/>}
                </Map>
              </div>

              <div className="ccv2-summary-card">
                <h2 className="ccv2-summary-title">{intl.formatMessage({id: 'JOURNEY'})}</h2>
                <dl className="ccv2-summary-list">
                  <div className="ccv2-summary-row"><dt>{intl.formatMessage({id: 'STARTING_ADDRESS'})}</dt><dd>{bookingInfos.startingAddress}</dd></div>
                  {bookingInfos.arrivalAddress &&
                    <div className="ccv2-summary-row"><dt>{intl.formatMessage({id: 'ARRIVAL_ADDRESS'})}</dt><dd>{bookingInfos.arrivalAddress}</dd></div>}
                  <div className="ccv2-summary-row"><dt>{intl.formatMessage({id: 'VEHICLE'})}</dt><dd>{bookingInfos.vehicle}</dd></div>
                  {bookingInfos.passengers > 0 &&
                    <>
                      <div className="ccv2-summary-row"><dt>{intl.formatMessage({id: 'PASSENGERS'})}</dt><dd>{bookingInfos.passengers}</dd></div>
                      <div className="ccv2-summary-row"><dt>{intl.formatMessage({id: 'BAGGAGE'})}</dt><dd>{bookingInfos.baggage}</dd></div>
                    </>
                  }
                  <div className="ccv2-summary-row">
                    <dt>{intl.formatMessage({id: 'ONE_WAY_OR_ROUND_TRIP'})}</dt>
                    <dd>{bookingInfos.route === 'ROUND_TRIP' ? intl.formatMessage({id: 'ROUND_TRIP'}) : intl.formatMessage({id: 'ONE_WAY'})}</dd>
                  </div>
                  <div className="ccv2-summary-row">
                    <dt>{bookingInfos.returnPickUpTime ? intl.formatMessage({id: 'ONE_WAY_DATES_AND_TIMES'}) : intl.formatMessage({id: 'DATES_AND_TIMES'})}</dt>
                    <dd>{bookingInfos.pickUpTime}</dd>
                  </div>
                  {bookingInfos.returnPickUpTime &&
                    <div className="ccv2-summary-row"><dt>{intl.formatMessage({id: 'RETURN_DATES_AND_TIMES'})}</dt><dd>{bookingInfos.returnPickUpTime}</dd></div>}
                  <div className="ccv2-summary-row"><dt>{intl.formatMessage({id: 'TRAVEL_TIME'})}</dt><dd>{bookingInfos.durationMinutes} {intl.formatMessage({id: 'MINUTES_UNIT'})}</dd></div>
                  <div className="ccv2-summary-row"><dt>{intl.formatMessage({id: 'DISTANCE'})}</dt><dd>{bookingInfos.distance} {bookingInfos.lengthUnit}</dd></div>
                  {bookingInfos.options && bookingInfos.options.map((o, i) =>
                    <div className="ccv2-summary-row ccv2-summary-option" key={i}>
                      <dt>{o.name}</dt>
                      <dd>
                        <span className="ccv2-opt-qty">×{o.quantity}</span>
                        {o.price > 0 && <span className="ccv2-opt-price">{formatter.format(o.price)}</span>}
                      </dd>
                    </div>)}
                </dl>
              </div>

              {validDiscount &&
                <div className="ccv2-price-block">
                  <span className="ccv2-price-base is-struck">{formatter.format(bookingInfos.price)}</span>
                  <p className="ccv2-discount-msg">{discountMessage}</p>
                </div>
              }

              {!booked &&
                <div className="ccv2-cta-bar">
                  <div className="ccv2-cta-price">
                    <span className="ccv2-cta-price-label">{intl.formatMessage({id: 'TOTAL'})}</span>
                    <span className="ccv2-cta-price-amount">
                      {validDiscount && <s>{formatter.format(bookingInfos.price)}</s>}
                      {formatter.format(validDiscount ? discountPrice : bookingInfos.price)}
                    </span>
                  </div>
                  <Button type="submit" className="ccv2-cta-btn ccv2-btn ccv2-btn-primary" disabled={loading}>
                    {loading && <i className="spinner-border spinner-border-sm text-light"/>}
                    {!loading && intl.formatMessage({id: paymentMode === 'ONLINE' ? (paymentUrl ? 'IOS_ONLINE_PAYMENT' : 'GO_TO_PAYMENT') : 'CONFIRM_BOOKING'})}
                  </Button>
                </div>
              }
            </aside>
          </div>
        </Form>}

      {bookingInfos.cgv && bookingInfos.cgv.type === 'TEXT' &&
        <Modal centered scrollable size="lg" show={showCgv} onHide={() => setShowCgv(false)}>
          <Modal.Header>
            <Modal.Title className="h6"><FormattedMessage id="CGV_TITLE"/></Modal.Title>
            <Button variant="close" aria-label="Close" onClick={() => setShowCgv(false)}/>
          </Modal.Header>
          <Modal.Body><div className="ccv2-cgv-body">{bookingInfos.cgv.text}</div></Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => {
              setFormData({name: 'cgvAccepted', value: true});
              setShowCgv(false);
            }}>
              <FormattedMessage id="CGV_ACCEPT_BUTTON"/>
            </Button>
            <Button variant="link" className="text-gray ms-auto" onClick={() => setShowCgv(false)}>
              <FormattedMessage id="CLOSE"/>
            </Button>
          </Modal.Footer>
        </Modal>}
    </main>
  );
};